<template>
    <div class="planShowCom">
        <div class="search_container">
            <!-- <base-search></base-search> -->
            <el-form size="mini" ref="form" class="searchBox" :inline="true" :model="formData">
                <el-form-item label="计划名称">
                    <el-input v-model="formData.schemeName" @change="getschemeList(1)" clearable placeholder="请输入计划名称"></el-input>
                </el-form-item>
                <el-form-item label="专业类型" class="mySelect">
                    <el-select v-model="formData.professionId" @change="getschemeList(1)" clearable @clear="() => formData.raceType = ''" placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in ProfessionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="大赛类型" class="mySelect">
                    <el-select v-model="formData.raceType" clearable placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in RaceTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="计划状态" class="mySelect">
                    <el-select v-model="formData.queryStatus" @change="getschemeList(1)" clearable placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in PlanStatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-button type="primary" size="mini" @click="getschemeList(1)">查询</el-button>
        </div>
        <div class="comPractice_container">
            <div class="button_box">
                <el-button type="primary" size="mini" @click="addPlanBtn">新建计划</el-button>
            </div>
            <basic-table v-loading="loading" :isCheckbox='true' :tableHeader="competitionPracticePlan" :tableData="tableData">
                <template slot-scope="data">
                    <!-- 
                        "status": 
                        0  大计划未发布  1   大计划发布
                     -->
                    <el-button size="mini" @click="getPublish(data.row)" type="text" v-if="data.row.status == 0">发布</el-button>
                    <el-button size="mini" @click="getEditBtn(data.row)" type="text">编辑</el-button>
                    <el-button size="mini" @click="getPaperTest(data.row, 1)" type="text">试卷</el-button>
                    <el-button size="mini" @click="getDelete(data.row)" type="text">删除</el-button>
                    <el-button size="mini" @click="getManage(data.row, 2)" v-if="data.row.status == 1" type="text">管理</el-button>
                    <el-button size="mini" @click="getOffline(data.row)" v-if="data.row.status  == 1 && data.row.isClose == 0" type="text">下线</el-button>
                    <el-button size="mini" @click="getOnline(data.row)" v-if="data.row.status  == 1 && data.row.isClose != 0" type="text">上线</el-button>
                </template>
            </basic-table>
            <pagination :total="total" :limit.sync="limitSize" :page.sync="pageNo" @currentChange="currentChange"></pagination>
        </div>

        <!-- 新建计划 -->
        <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="addDialogVisible" class="addPlanDialog" width="687px" :before-close="AddhandleClose">
            <div class="dialog_search">
                <el-form :rules="rules" size="mini" ref="newPlanFormOne" :inline="true" :model="formDataCopy">
                    <div class="formcenter">
                        <el-form-item label="计划名称" prop="schemeName">
                            <el-input v-model="formDataCopy.schemeName" clearable style="width: 172px;" placeholder="请输入计划名称"></el-input>
                        </el-form-item>
                        <span style="margin: 0 5px; width:31px; height: 10px; display:inline-block;"></span>
                        <!-- 开始日期 -->
                        <el-form-item label="开始日期" prop="beginTime">
                            <el-date-picker v-model="formDataCopy.beginTime" style="width: 184px;" @change="changeTimeBegin" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptionsStartDateTime" clearable type="datetime" placeholder="选择开始日期">
                            </el-date-picker>
                        </el-form-item>
                    </div>

                    <div class="formcenter">
                        <el-form-item label="专业类型" prop="professionId">
                            <el-select v-model="formDataCopy.professionId" @change="changePersonID" style="width: 172px;" :disabled="bigDaSaiStatus == 1" placeholder="全部">
                                <el-option v-for="item in ProfessionList" clearable :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <span style="margin: 0 5px; width:31px; height: 10px; display:inline-block;"></span>
                        <!-- 结束日期 -->
                        <el-form-item label="结束日期" prop="endTime">
                            <el-date-picker v-model="formDataCopy.endTime" style="width: 184px;" @change="changeEndTime" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptionsEndDateTime" clearable type="datetime" placeholder="选择结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="formLeft">
                        <el-form-item label="大赛类型" prop="raceType">
                            <el-select v-model="formDataCopy.raceType" style="width: 172px;" placeholder="全部" :disabled="bigDaSaiStatus == 1">
                                <el-option v-for="item in RaceTypeList" clearable :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <span style="margin: 0 5px; width:31px; height: 10px; display:inline-block;"></span>
                        <el-form-item label="关联科目" prop="subjectId" v-if="subjectShow">
                            <el-select v-model="formDataCopy.subjectId" style="width: 185px;" placeholder="全部" :disabled="bigDaSaiStatus == 1">
                                <el-option v-for="item in subjectJzList" clearable :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="formLeft_copy">
                        <span>可用省份</span> <span style="color: #409EFF; font-size:12px;  margin-left:5px;">请勾选该计划可用的省份,日期如不单独设置则默认同计划日期</span>
                        <el-form-item label="报名来源" prop="entrySource" >
                            <el-select v-model="formDataCopy.entrySource" style="width: 135px;" placeholder="选择报名来源" :disabled="bigDaSaiStatus == 1">
                                <el-option v-for="item in signUpList" clearable :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
                

                <div class="basicTable">
                    <basic-table :isCheckbox='true' :title="title" :planEditBeginTime="planEditBeginTime" :planEditEndTime="planEditEndTime" :planEndTime="planEndTime" :planBeginTime="planBeginTime" :isAddPrance="true" ref="basicPrviceTable" :isOperate="false" @operation="operation" :tableHeader="provinceList" :tableData="provinceData"></basic-table>
                    <span style="color: #409EFF; font-size:12px;  margin-left:5px;">已选省份 : </span> <span style="color: red;">{{selectProvinceData.length}}</span>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="cancelBtn">取 消</el-button>
                <el-button size="mini" type="primary" @click="addNewPlanBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { competitionPracticePlan, provinceList } from '../globalData'
import fetch from '@/api/fetch'

export default {
    name: 'planShow',

    data() {
        /**
         *  el-date-picker组件判断开始时间不能大于结束时间
         */
        var validateStartDatetime = (rule, value, callback) => {
            if (this.formDataCopy.endTime && this.formDataCopy.beginTime) {
                if (
                    new Date(this.formDataCopy.beginTime).getTime() >=
                    new Date(this.formDataCopy.endTime).getTime()
                ) {
                    callback(new Error("开始时间需要小于结束时间！"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        var validateEndDatetime = (rule, value, callback) => {
            if (this.formDataCopy.beginTime && this.formDataCopy.endTime) {
                if (
                    new Date(this.formDataCopy.beginTime).getTime() >
                    new Date(this.formDataCopy.endTime).getTime()
                ) {
                    callback(new Error("结束时间需要大于开始时间！"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        return {
            title: '新建计划',
            loadingCopy: false,
            loading: false,
            competitionPracticePlan: competitionPracticePlan,
            provinceList: provinceList,
            tableData: [],
            provinceData: [],
            formData: {
                raceType: '',
                professionId: '',
                schemeName: '',
                queryStatus: '',
            },
            pageNo: 1,
            limitSize: 10,
            total: 0,
            formDataCopy: {
                raceType: '',
                professionId: '',
                schemeName: '',
                beginTime: null,
                endTime: null,
                subjectId: '',
                entrySource: ''
            },
            PlanStatus: [ // 0 未发布 1 未开始 2进行中 3 已结束
                { id: 0, name: '未发布', value: 0 },
                { id: 1, name: '未开始', value: 1 },
                { id: 2, name: '进行中', value: 2 },
                { id: 3, name: '已结束', value: 3 },
            ],
            signUpList: [
                {id: 0, name: '管理员申报', value: 0},
                {id:1, name: '官网注册申报', value: 1}
            ],
            ProfessionList: [],
            OrgTypeList: [],
            RaceTypeList: [],
            addDialogVisible: false,
            selectProvinceData: [], // 选中省份数据
            arr: [],
            array: [],
            bigDaSaiStatus: '', // 大赛计划 0 - 未发布  1 - 已发布
            pickerOptionsStartDateTime: {
                disabledDate: (time) => {  //设置禁用范围  
                    if (this.formDataCopy.endTime) {
                        return (
                            //  || time.getTime() < Date.now()
                            time.getTime() >= new Date(this.formDataCopy.endTime.slice(0, 10)).getTime()
                        );
                    } else {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
            },
            pickerOptionsEndDateTime: {
                disabledDate: (time) => {
                    if (this.formDataCopy.beginTime) {
                        return (
                            time.getTime() < new Date(this.formDataCopy.beginTime.slice(0, 10)).getTime() - 8.64e7 || time.getTime() < Date.now() - 8.64e7
                        );
                    }
                    else {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
            },
            rules: {
                schemeName: [{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }, { required: true, message: '请输入计划名称', trigger: 'blur' }],
                professionId: { required: true, message: '专业类型不能为空', trigger: 'change' },
                entrySource: { required: true, message: '报名来源不能为空', trigger: 'change' },
                raceType: { required: true, message: '大赛类型不能为空', trigger: 'change' },
                subjectId: { required: true, message: '科目类型不能为空', trigger: 'change' },
                beginTime: [{ validator: validateStartDatetime, message: '开始时间需要小于结束时间！', trigger: "change" }, { required: true, message: '开始时间不能为空', trigger: 'blur' }],
                endTime: [{ validator: validateEndDatetime, message: '结束时间需要大于开始时间！', trigger: "change" }, { required: true, message: '结束时间不能为空', trigger: 'blur' }],
            },
            editRowData: {}, // 编辑数据
            newArr: [],
            planEndTime: false,
            planBeginTime: false,
            planEditBeginTime: false,
            planEditEndTime: false,
            subjectJzList: []
        };
    },

    mounted() {
        this.getschemeList()
        this.getProfessionListUrl()
        this.getOrgTypeListUrl()
    },
    methods: {
        changePersonID(val) {
            this.formDataCopy.raceType = ''
            this.formDataCopy.subjectId = ''
            if (val) {
                this.getRaceTypeListUrl(val)
                this.getSubjectJzList(val)
            } else {
                this.RaceTypeList = []
                this.subjectJzList = []
            }
        },
        async getEditBtn(rowData) {
            this.editRowData = rowData
            console.log(rowData, 'rowData')
            /**
             *  status - 用来判断 
             *  0 - 大计划未发布
             *  1 - 大计划发布
             */
            this.bigDaSaiStatus = rowData.status
            this.title = '编辑计划'
            await this.getProvinceList()
            this.addDialogVisible = true
            // formDataCopy.raceType
            this.getRaceTypeListUrl(rowData.professionId)
            this.getSubjectJzList(rowData.professionId)
            this.editBeforeFun({ id: rowData.id })

        },
        editBeforeFun(data) {
            console.log(data)
            fetch.editGetById(data).then(res => {
                if (res.code == '0') {
                    this.formDataCopy = res.data
                    this.planEditBeginTime = this.formDataCopy.beginTime
                    this.planEditEndTime = this.formDataCopy.endTime
                    if (this.bigDaSaiStatus == 0) { // 大计划未发布 - 所有项可编辑, 大计划发布 - 不能修改专业类型和大赛类型。不能去掉省份、可以增加勾选。
                        // 大计划未发布
                        let selectData = res.data.schemeProvinceList.map(item => {
                            return { id: item.id, provinceId: item.provinceId, beginTime: item.beginTime, endTime: item.endTime, name: item.provinceName, isEdited: 0 }
                        })
                        this.provinceData.forEach((item, index, arr) => {
                            for (let ele = 0; ele < selectData.length; ele++) {
                                if (selectData[ele].provinceId == item.provinceId) {
                                    arr.splice(index, 1, selectData[ele])
                                }
                            }
                        })

                        this.$nextTick(() => {
                            this.$refs.basicPrviceTable.$refs.basicTable.$parent.getEditchange(selectData)
                        });

                    } else {
                        // 大计划发布
                        let selectData = res.data.schemeProvinceList.map(item => {
                            return { id: item.id, provinceId: item.provinceId, beginTime: item.beginTime, endTime: item.endTime, name: item.provinceName, isEdited: 1 }
                        })
                        this.provinceData.forEach((item, index, arr) => {
                            for (let ele = 0; ele < selectData.length; ele++) {
                                if (selectData[ele].provinceId == item.provinceId) {
                                    arr.splice(index, 1, selectData[ele])
                                }
                            }
                        })


                        this.$nextTick(() => {
                            this.$refs.basicPrviceTable.$refs.basicTable.$parent.getEditchange(selectData)
                        });
                    }

                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        cancelBtn() {
            this.addDialogVisible = false
            this.formDataCopy = {
                raceType: '',
                professionId: '',
                schemeName: '',
                beginTime: null,
                endTime: null,
                subjectId: '',
                entrySource: ''
            },
                this.provinceData = []
            this.bigDaSaiStatus = ''
            this.$refs.newPlanFormOne.clearValidate();
            this.$refs.basicPrviceTable.$refs.basicTable.$parent.getClearSelect()
        },
        addNewPlanBtn() { // 新建计划
            if (this.title == '新建计划') {
                this.$refs.newPlanFormOne.validate((valid) => {
                    if (valid) {
                        if (this.selectProvinceData.length <= 0) {
                            this.$message.error('请选择至少一个省份')
                        } else {
                            // 存储有问题的数据
                            let arr = []

                            this.selectProvinceData.forEach(item => {

                                if (item.beginTime != null && item.endTime != null) {
                                    if (((new Date(item.endTime)).getTime() > (new Date(this.formDataCopy.endTime)).getTime() || (new Date(item.endTime)).getTime() < (new Date(this.formDataCopy.beginTime)).getTime() || (new Date(item.endTime)).getTime() < (new Date(item.beginTime)).getTime() || (new Date(item.beginTime)).getTime() < (new Date(this.formDataCopy.beginTime)).getTime() || (new Date(item.beginTime)).getTime() > (new Date(this.formDataCopy.endTime)).getTime())) {
                                        arr.push(item)
                                    }
                                } else if (item.beginTime == null && item.endTime != null) {

                                    if ((new Date(item.endTime)).getTime() < (new Date(this.formDataCopy.beginTime)).getTime() || (new Date(item.endTime)).getTime() > (new Date(this.formDataCopy.endTime)).getTime()) {
                                        arr.push(item)
                                    }
                                } else if (item.endTime == null && item.beginTime != null) {
                                    if ((new Date(item.beginTime)).getTime() > (new Date(this.formDataCopy.endTime)).getTime() || (new Date(item.beginTime)).getTime() < (new Date(this.formDataCopy.beginTime)).getTime()) {
                                        arr.push(item)
                                    }
                                } else if (item.endTime == null && item.beginTime == null) {
                                    console.log('123')
                                }
                            })

                            if (arr.length >= 1) {
                                this.$message.error('省份时间设置有误! 请检查省份时间.')
                            } else {
                                this.getNewPlanFun()
                                this.getschemeList()
                            }
                        }

                    } else {
                        return false;
                    }
                })

            } else {
                this.$refs.newPlanFormOne.validate((valid) => {
                    if (valid) {
                        // 存储有问题的数据
                        let arr = []

                        this.selectProvinceData.forEach(item => {

                            if (item.beginTime != null && item.endTime != null) {
                                if (((new Date(item.endTime)).getTime() > (new Date(this.formDataCopy.endTime)).getTime() || (new Date(item.endTime)).getTime() < (new Date(this.formDataCopy.beginTime)).getTime() || (new Date(item.endTime)).getTime() < (new Date(item.beginTime)).getTime() || (new Date(item.beginTime)).getTime() < (new Date(this.formDataCopy.beginTime)).getTime() || (new Date(item.beginTime)).getTime() > (new Date(this.formDataCopy.endTime)).getTime())) {
                                    arr.push(item)
                                }
                            } else if (item.beginTime == null && item.endTime != null) {

                                if ((new Date(item.endTime)).getTime() < (new Date(this.formDataCopy.beginTime)).getTime() || (new Date(item.endTime)).getTime() > (new Date(this.formDataCopy.endTime)).getTime()) {
                                    arr.push(item)
                                }
                            } else if (item.endTime == null && item.beginTime != null) {
                                if ((new Date(item.beginTime)).getTime() > (new Date(this.formDataCopy.endTime)).getTime() || (new Date(item.beginTime)).getTime() < (new Date(this.formDataCopy.beginTime)).getTime()) {
                                    arr.push(item)
                                }
                            } else if (item.endTime == null && item.beginTime == null) {
                                console.log('123')
                            }
                        })

                        if (arr.length >= 1) {
                            this.$message.error('省份时间设置有误! 请检查省份时间.')
                        } else {
                            this.getEditPlanFun()
                            this.getschemeList()
                        }

                    } else {
                        return false;
                    }
                })
            }
        },
        getEditPlanFun() {
            // console.log(this.formDataCopy)
            fetch.getEditUpdate({ ...this.formDataCopy, schemeProvinceList: this.selectProvinceData }).then(res => {
                if (res.code == '0') {
                    this.addDialogVisible = false
                    this.formDataCopy = {
                        raceType: '',
                        professionId: '',
                        schemeName: '',
                        beginTime: null,
                        endTime: null,
                        subjectId: '',
                        entrySource: ''
                    },
                        this.provinceData = []
                    this.$refs.basicPrviceTable.$refs.basicTable.$parent.getClearSelect()
                    this.$message.success(res.msg)
                    this.getschemeList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getNewPlanFun() { // 新建计划方法
            fetch.getAddschemeUrl({
                ...this.formDataCopy, schemeProvinceList: this.selectProvinceData
            }).then(res => {
                if (res.code == '0') {
                    // console.log(res)
                    this.addDialogVisible = false
                    this.formDataCopy = {
                        raceType: '',
                        professionId: '',
                        schemeName: '',
                        beginTime: null,
                        endTime: null,
                        subjectId: '',
                        entrySource: ''
                    },
                        this.provinceData = []
                    this.$refs.basicPrviceTable.$refs.basicTable.$parent.getClearSelect()
                    this.$message.success(res.msg)
                    this.getschemeList()
                } else {
                    this.loadingCopy = false
                    this.$message.error(res.msg)
                }
            })
        },
        async addPlanBtn() {
            this.title = '新建计划'
            this.addDialogVisible = true
            await this.$nextTick(() => {
                this.$refs.newPlanFormOne.clearValidate();
            });
            await this.getProvinceList()
            // 默认全部勾选
            // this.$nextTick(() => {
            //     this.$refs.basicPrviceTable.$refs.basicTable.$parent.getAllchange()
            // });
        },
        AddhandleClose() {
            this.addDialogVisible = false
            this.formDataCopy = {
                raceType: '',
                professionId: '',
                schemeName: '',
                beginTime: null,
                endTime: null,
                subjectId: '',
                entrySource: ''
            },
                this.provinceData = []
            this.bigDaSaiStatus = ''
            this.$refs.newPlanFormOne.clearValidate();
            this.$refs.basicPrviceTable.$refs.basicTable.$parent.getClearSelect()
        },
        getDelete(rowData) { // 删除计划
            if (rowData.passNum > 0) {
                this.$confirm('该计划下有已报名院校不可删除！', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => { }).catch(() => { });
            } else {
                this.$confirm('此操作将永久删除该计划, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 删除接口
                    fetch.deletescheme({ id: rowData.id }).then(res => {
                        if (res.code == '0') {
                            this.$message.success(res.msg)
                            this.getschemeList()
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },
        getOffline(rowData) { // 下线计划
            console.log(rowData)
            this.$confirm('下线计划会影响该计划关联的机构使用! 是否下线该计划', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 调用下线接口
                fetch.downLineScheme({ id: rowData.id }).then(res => {
                    if (res.code == '0') {
                        this.$message.success(res.msg)
                        this.getschemeList()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {
                this.$message.info('已取消')
            });
        },
        getOnline(rowData) { // 上线
            // console.log(rowData)
            fetch.upLineScheme({ id: rowData.id }).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg)
                    this.getschemeList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getschemeList(page) { // 初始化table
            this.loading = true
            this.pageNo = page ? page : 1
            fetch.getschemeList({ ...this.formData, pageNo: this.pageNo, limitSize: this.limitSize }).then(res => {
                if (res.code == '0') {
                    let schemeStatusList = {
                        0: '未发布',
                        1: '未开始',
                        2: '进行中',
                        3: '已结束'
                    }
                    this.formData.raceType = ''
                    this.formData.professionId ? this.getRaceTypeListUrl(this.formData.professionId) : this.RaceTypeList = []
                    this.tableData = res.data.records.map(item => {
                        return { ...item, schemeStatusName: schemeStatusList[item.schemeStatus], planTime: `${item.beginTime || ''} - ${item.endTime || ''}` }
                    })
                    this.loading = false
                    this.total = res.data.total
                    this.pageNo = res.data.current
                    this.limitSize = res.data.size
                } else {
                    this.loading = false
                    this.$message.error(res.msg)
                }
            })
        },
        getProfessionListUrl() { // 专业下拉
            fetch.getProfessionListUrl().then(res => {
                if (res.code == '0') {
                    this.ProfessionList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getOrgTypeListUrl() { // 机构类型下拉
            fetch.getOrgTypeListUrl().then(res => {
                if (res.code == '0') {
                    this.OrgTypeList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getRaceTypeListUrl(val) { // 大赛类型下拉
            fetch.getRaceTypeListUrl({professionId: val}).then(res => {
                if (res.code == '0') {
                    this.RaceTypeList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getPublish(rowData) { // 发布
            fetch.getSchemePublish({ id: rowData.id }).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg)
                    this.getschemeList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        async getProvinceList() { // 获取省份
            const res = await fetch.getProvinceList()
            if (res.code == '0') {
                this.provinceData = res.data.map(item => {
                    return { ...item, beginTime: null, endTime: null, name: item.name, provinceId: item.id }
                })
            } else {
                this.$message.error(res.msg)
            }
        },
        operation(val, rowData) {
            this.arr = rowData
            if (val == 'selectChange') {
                let data = rowData.map(item => {
                    if (rowData.beginTime && rowData.endTime) {
                        return { ...item, provinceId: item.id }
                    } else {
                        return false
                    }
                }).filter(item => item)
                this.arr.push(...data)

                this.selectProvinceData = this.arr

            } else if (val == 'select') {

                // if (rowData.beginTime && rowData.endTime) {
                //     if (Array.isArray(this.arr)) {
                //         this.arr.map(item => {
                //             if (rowData.id == item.id) {
                //                 this.arr.push(item)
                //             }
                //         })
                //         this.selectProvinceData = this.array
                //     }
                // }
                // if(rowData.isEdited) {
                //     this.newArr.forEach(item => {
                //         if(rowData.id == item.id) {
                //             this.newArr.push(item)
                //         }
                //     })
                //    this.selectProvinceData = [...new Set(this.newArr)]
                // //    console.log(this.selectProvinceData)
                // }

            }
        },
        currentChange(val) {
            this.pageNo = val.page
            this.limitSize = val.limit
            this.getschemeList(this.pageNo)
        },
        getManage(rowData, active) { // 管理
            this.$emit('changeActive', active, rowData)
        },
        getPaperTest(rowData, active) {
            this.$emit('changeActive', active, rowData)
        },
        changeTimeBegin(val) {
            this.planBeginTime = val
            console.log(this.planBeginTime)
            if (this.title == '新建计划') {
                this.getProvinceList()
            } else {
                fetch.editGetById({ id: this.editRowData.id }).then(res => {
                    if (res.code == '0') {
                        if (this.bigDaSaiStatus == 0) { // 大计划未发布 - 所有项可编辑, 大计划发布 - 不能修改专业类型和大赛类型。不能去掉省份、可以增加勾选。
                            // 大计划未发布
                            let selectData = res.data.schemeProvinceList.map(item => {
                                return { id: item.id, provinceId: item.provinceId, beginTime: null, endTime: null, name: item.provinceName, isEdited: 0 }
                            })
                            this.provinceData.forEach((item, index, arr) => {
                                for (let ele = 0; ele < selectData.length; ele++) {
                                    if (selectData[ele].provinceId == item.provinceId) {
                                        arr.splice(index, 1, selectData[ele])
                                    }
                                }
                            })
                            // 对选中的数据进行重新赋值
                            this.selectProvinceData = selectData

                            this.$nextTick(() => {
                                this.$refs.basicPrviceTable.$refs.basicTable.$parent.getEditchange(selectData)
                            });

                        } else {
                            // 大计划发布
                            let selectData = res.data.schemeProvinceList.map(item => {
                                return { id: item.id, provinceId: item.provinceId, beginTime: null, endTime: null, name: item.provinceName, isEdited: 1 }
                            })
                            this.provinceData.forEach((item, index, arr) => {
                                for (let ele = 0; ele < selectData.length; ele++) {
                                    if (selectData[ele].provinceId == item.provinceId) {
                                        arr.splice(index, 1, selectData[ele])
                                    }
                                }
                            })
                            // 对选中的数据进行重新赋值
                            this.selectProvinceData = selectData

                            this.$nextTick(() => {
                                this.$refs.basicPrviceTable.$refs.basicTable.$parent.getEditchange(selectData)
                            });
                        }

                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        changeEndTime(val) { // 新建计划改变结束时间 - 解决planEndTime时间赋值问题
            this.planEndTime = val
            if (this.title == '新建计划') {
                this.getProvinceList()
            } else {
                fetch.editGetById({ id: this.editRowData.id }).then(res => {
                    if (res.code == '0') {
                        if (this.bigDaSaiStatus == 0) { // 大计划未发布 - 所有项可编辑, 大计划发布 - 不能修改专业类型和大赛类型。不能去掉省份、可以增加勾选。
                            // 大计划未发布
                            let selectData = res.data.schemeProvinceList.map(item => {
                                return { id: item.id, provinceId: item.provinceId, beginTime: null, endTime: null, name: item.provinceName, isEdited: 0 }
                            })
                            this.provinceData.forEach((item, index, arr) => {
                                for (let ele = 0; ele < selectData.length; ele++) {
                                    if (selectData[ele].provinceId == item.provinceId) {
                                        arr.splice(index, 1, selectData[ele])
                                    }
                                }
                            })
                            // 对选中的数据进行重新赋值
                            this.selectProvinceData = selectData

                            this.$nextTick(() => {
                                this.$refs.basicPrviceTable.$refs.basicTable.$parent.getEditchange(selectData)
                            });

                        } else {
                            // 大计划发布
                            let selectData = res.data.schemeProvinceList.map(item => {
                                return { id: item.id, provinceId: item.provinceId, beginTime: null, endTime: null, name: item.provinceName, isEdited: 1 }
                            })
                            this.provinceData.forEach((item, index, arr) => {
                                for (let ele = 0; ele < selectData.length; ele++) {
                                    if (selectData[ele].provinceId == item.provinceId) {
                                        arr.splice(index, 1, selectData[ele])
                                    }
                                }
                            })
                            // 对选中的数据进行重新赋值
                            this.selectProvinceData = selectData

                            this.$nextTick(() => {
                                this.$refs.basicPrviceTable.$refs.basicTable.$parent.getEditchange(selectData)
                            });
                        }

                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }

        },
        async getSubjectJzList(val) {
            const res = await fetch.getSubjectJzList({professionId: val})
            console.log(res)
            this.subjectJzList = res.data
        }
    },
    components: {
        // BaseSearch: () => import('../../components/baseSearch.vue'),
        BasicTable: () => import('@/components/basicTable.vue'),
        Pagination: () => import('@/components/pagination.vue')
    },
    computed: {
        subjectShow: function() {
            const obj = this.ProfessionList.filter(v => v.id === this.formDataCopy.professionId)[0]
            return obj ? obj.isShowSubject : false
        }
    }
};
</script>

<style lang="scss" scoped>
.planShowCom {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .search_container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding-left: 20px;
        box-sizing: border-box;
    }
    .comPractice_container {
        width: 100%;
        height: calc(100% - 80px);
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 10px 20px 20px 20px;
        box-sizing: border-box;
    }
    .button_box {
        display: flex;
        height: 60px;
        justify-content: flex-end;
        align-items: center;
    }
    .searchBox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        /deep/.el-form-item {
            margin-bottom: 0;
        }
    }
    .mySelect {
        /deep/.el-select {
            /deep/.el-input {
                width: 100px;
            }
        }
    }
    .addPlanDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        /deep/ .el-dialog__body {
            padding-bottom: 0px;
        }
        /deep/ .el-dialog__footer {
            padding-top: 0px;
        }
        .formcenter {
            // text-align: center;
        }
        .formLeft {
            // padding-left: 17px;
            box-sizing: border-box;
        }
        .formLeft_copy {
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            /deep/.el-form-item {
                margin-bottom: 0;
            } 
        }
    }
    .basicTable {
        margin-top: 20px;
        height: 393px;
    }
}
</style>